import styled, { css } from 'styled-components';
import completeIcon from 'images/icons/reportComplete.svg';

const radioIcons = {};

export const StepContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 60px 0;

  & > * {
    vertical-align: top;
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.palette[3]};
  font-size: 30px;
  font-weight: 100;
  margin: 0 auto 19px;
`;

export const RadioItemTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 13px;
  align-items: center;
  letter-spacing: 2px;
  color: #446D93;
  margin-bottom: 12px;
  text-align: left;
`;

export const RadioItemDesc = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 1.6;
  color: #939AAB;
  text-align: left;
`;

export const RadioItem = styled.div`
  background-color: #FFFFFF;
  background-image: url(${({ type }) => radioIcons[type]}) 12px center no-repeat;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  color: #939AAB;
  width: ${({ width }) => width || '230px'};
  height: ${({ height }) => height || '304px'};
  margin-right: 11px;
  cursor: pointer;
  transition: all .3s cubic-bezier(0.29, 1.02, 0.58, 1);
  padding: 170px 36px 36px 40px;
  display: inline-block;
  text-align: left;
  vertical-align: top;

  &:hover {
    background: #2D8BFF;
    color: white;

    ${RadioItemDesc},
    ${RadioItemTitle} {
      color: white;
    }
  }

  ${({ selected }) => selected && css`
    background: #2D8BFF;
    color: white;

    ${RadioItemDesc},
    ${RadioItemTitle} {
      color: white;
    }
  `}

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(-3px);
  }
`;

export const SelectionContainer = styled.div`
  border-bottom: 1px solid #E4E5E9;
  padding: 10px 0;
  margin-bottom: 8px;
  text-align: left;
`;

export const CompleteLogo = styled.div`
  margin: 24px auto;
  width: 60px;
  height: 60px;
  background: url(${completeIcon}) center no-repeat;
`;
